<template>
  <div
    class="modal fade"
    id="zoomImageModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="zoomImageModalLabel"
    aria-hidden="true"
    @click="$refs.imageBox.resetZoom()"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$refs.imageBox.resetZoom()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="overflow:hidden">
          <Pinch
            :src="imageSelected"
            :min-zoom="1"
            :max-zoom="2.5"
            ref="imageBox"
          ></Pinch>
          <div v-if="!imageSelected" class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>eye</th>
                  <th>a</th>
                  <th>b</th>
                  <th>ed</th>
                  <th>dbl</th>
                  <th>temples</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, key) in measureSelected" :key="key">
                  <td v-for="(col, index) in row" :key="index">{{ col }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between ml-2">
          <div>
            <!-- Keep div to have justify-content-between even when showVariants==false -->
            <form v-if="showVariants" class="form-inline">
              <label class="d-none d-sm-block mr-2">
                <b>COLORS:</b>
              </label>
              <select class="form-control mr-sm-2" v-model="imageSelected">
                <option
                  v-for="varcol in variants"
                  :value="S3URL + varcol.src"
                  :selected="imageSelected"
                  :key="varcol.color"
                  >{{ varcol.color }}</option
                >
              </select>
            </form>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            @click="$refs.imageBox.resetZoom()"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pinch from "./Pinch.vue";

export default {
  name: "ZoomModal",
  components: { Pinch },
  props: {
    S3URL: { type: String, default: "" }
  },
  data: function() {
    return {
      imageSelected: "",
      measureSelected: [], // array of measures
      variants: []
    };
  },
  computed: {
    showVariants: function() {
      return (
        this.imageSelected && this.$route.path.substring(1) !== "favorites"
      );
    }
  },
  methods: {
    showImage(obj) {
      this.imageSelected = obj.imageSelected;
      this.measureSelected = obj.measureSelected;
      this.variants = obj.variants;
    }
  }
};
</script>
